var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0001 18.3328C13.9904 18.3328 17.2251 15.0981 17.2251 11.1078C17.2251 7.11756 13.9904 3.88281 10.0001 3.88281C6.00989 3.88281 2.77515 7.11756 2.77515 11.1078C2.77515 15.0981 6.00989 18.3328 10.0001 18.3328Z",
    fill: "#008c80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.4557C9.65833 11.4557 9.375 11.1724 9.375 10.8307V6.66406C9.375 6.3224 9.65833 6.03906 10 6.03906C10.3417 6.03906 10.625 6.3224 10.625 6.66406V10.8307C10.625 11.1724 10.3417 11.4557 10 11.4557Z",
    fill: "#008c80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4081 2.8724H7.59145C7.25812 2.8724 6.99146 2.60573 6.99146 2.2724C6.99146 1.93906 7.25812 1.66406 7.59145 1.66406H12.4081C12.7415 1.66406 13.0081 1.93073 13.0081 2.26406C13.0081 2.5974 12.7415 2.8724 12.4081 2.8724Z",
    fill: "#008c80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon14);
export default __webpack_public_path__ + "static/media/menu-icon-14.c869a1b6d1f02cebeba9230b733b15bf.svg";
export { ForwardRef as ReactComponent };